<template>
  <div>
    <!-- 작업기간 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">작업기간</span></label>
      <div class="col-4 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          :value="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          @change="(val) => { permit.workPeriod = val; }"
          style="font-size: 12px;" input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>

    <!-- 운전원 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>운전원</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="addHeavyOperator">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr>
              <th>성명</th><th>면허</th><th>연락처</th><th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(op, idx) in permit.operators" :key="idx">
              <td><input type="text" class="form-control" v-model="op.name" placeholder="성명"></td>
              <td><input type="text" class="form-control" v-model="op.license" placeholder="면허종류"></td>
              <td><input type="text" class="form-control" v-model="op.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="removeHeavyOperator(idx)" :disabled="permit.operators.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 유도자 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>유도자</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="addHeavyGuide">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col style="width:200px;"><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr>
              <th>성명</th><th>신호방법</th><th>연락처</th><th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(guide, idx) in permit.guides" :key="idx">
              <td><input type="text" class="form-control" v-model="guide.name" placeholder="성명"></td>
              <td style="vertical-align: middle;">
                <label class="md-check mr-20"><input type="checkbox" v-model="guide.signalMethods" value="수신호"><i class="blue"></i>수신호</label>
                <label class="md-check"><input type="checkbox" v-model="guide.signalMethods" value="무선"><i class="blue"></i>무선</label>
                <input v-if="guide.signalMethods && guide.signalMethods.includes('무선')" type="text" class="form-control mt-5" v-model="guide.wirelessMeans" placeholder="무선수단 입력 (예: 무전기/채널)">
              </td>
              <td><input type="text" class="form-control" v-model="guide.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="removeHeavyGuide(idx)" :disabled="permit.guides.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 중량물운반방법 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span class="ess">중량물운반방법</span></label>
      <div class="col-10 pt-2">
        <label class="md-check mr-20"><input type="checkbox" v-model="permit.transportMethods" value="기계·장비 사용"><i class="blue"></i>기계·장비 사용</label>
        <label class="md-check mr-20"><input type="checkbox" v-model="permit.transportMethods" value="줄걸이 용구 등 사용"><i class="blue"></i>줄걸이 용구 등 사용</label>
        <label class="md-check"><input type="checkbox" v-model="permit.transportMethods" value="인력운반"><i class="blue"></i>인력운반</label>
      </div>
    </div>

    <!-- 기계·장비 제원 (기계·장비 사용 체크 시) -->
    <div v-if="permit.transportMethods.includes('기계·장비 사용')" class="form-group row">
      <label class="col-2 form-control-label"><span>기계·장비 제원</span></label>
      <div class="col-10 pt-2">
        <div v-for="(equip, eIdx) in permit.equipmentList" :key="equip.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <span style="font-weight:600;">장비 {{ eIdx + 1 }}</span>
            <button class="btn btn-xs line-2" @click="removeHeavyEquipmentEntry(eIdx)"
              :disabled="permit.equipmentList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <EquipCommonFields :equip="equip" :markRequired="true" :placeholders="{ modelName: '굴착기(CAT-000)', manufacturer: '00 기계', registrationNo: '부산 02가 0000', manufactureYear: '2026년', insuranceName: '00 보험' }">
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">규격(작업능력)</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.capacity" placeholder="000kg (최대적재하중, 허용하중 등)"></div>
                <label class="col-2 form-control-label pt-0">작업가능반경</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.workRadius" placeholder="최대 00m / 최저 00m"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">운반거리</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.transport" placeholder="수직(높이), 수평 운반거리"></div>
              </div>
            </EquipCommonFields>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addHeavyEquipmentEntry">
          <i class="icon-plus mr-5"></i>장비 추가
        </button>
      </div>
    </div>

    <!-- 줄걸이 용구 (줄걸이 용구 등 사용 체크 시) -->
    <div v-if="permit.transportMethods.includes('줄걸이 용구 등 사용')" class="form-group row">
      <label class="col-2 form-control-label"><span>줄걸이 용구</span></label>
      <div class="col-10 pt-2">
        <div v-for="(lift, lIdx) in permit.liftingList" :key="lift.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <span style="font-weight:600;">줄걸이 {{ lIdx + 1 }}</span>
            <button class="btn btn-xs line-2" @click="removeLiftingEntry(lIdx)"
              :disabled="permit.liftingList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">인양능력 검토 결과</label>
              <div class="col-10">
                <span class="text-888 mr-15" style="font-size:11px;">줄걸이 용구 최대 사용하중 &gt; 중량물 하중</span>
                <label class="md-check mr-20"><input type="radio" v-model="lift.liftFeasible" value="인양가능"><i class="blue"></i>인양 가능</label>
                <label class="md-check mr-20"><input type="radio" v-model="lift.liftFeasible" value="인양불가능"><i class="blue"></i>인양 불가능</label>
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">줄걸이 용구</label>
              <div class="col-10">
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="와이어로프"><i class="blue"></i>와이어로프</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="섬유로프"><i class="blue"></i>섬유로프</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="체인"><i class="blue"></i>체인</label>
                <label class="md-check mr-10"><input type="checkbox" v-model="lift.riggingToolOther"><i class="blue"></i>기타</label>
                <input v-if="lift.riggingToolOther" type="text" class="form-control mt-5"
                       v-model="lift.riggingToolOtherText" placeholder="기타 줄걸이 용구" style="max-width:300px;">
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">보조용구</label>
              <div class="col-10">
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="클램프"><i class="blue"></i>클램프</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="해커"><i class="blue"></i>해커</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="체인슬링"><i class="blue"></i>체인슬링</label>
                <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="러그"><i class="blue"></i>러그</label>
                <label class="md-check mr-10"><input type="checkbox" v-model="lift.auxiliaryToolOther"><i class="blue"></i>기타</label>
                <input v-if="lift.auxiliaryToolOther" type="text" class="form-control mt-5"
                       v-model="lift.auxiliaryToolOtherText" placeholder="기타 보조용구" style="max-width:300px;">
              </div>
            </div>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0">줄걸이 세부</label>
              <div class="col-10">
                <div class="row">
                  <div class="col-4 mb-10"><label class="wp-field-label">직경</label><input type="text" class="form-control" v-model="lift.diameter" placeholder="00 mm"></div>
                  <div class="col-4 mb-10"><label class="wp-field-label"><span class="ess">안전작업하중</span></label><input type="text" class="form-control" v-model="lift.safeWorkLoad" placeholder="00개"></div>
                  <div class="col-4 mb-10"><label class="wp-field-label">줄걸이 수</label><input type="text" class="form-control" v-model="lift.riggingCount"></div>
                  <div class="col-4"><label class="wp-field-label">하중계수(장력)</label><input type="text" class="form-control" v-model="lift.loadFactor"></div>
                  <div class="col-4"><label class="wp-field-label">안전계수</label><input type="text" class="form-control" v-model="lift.safetyFactor"></div>
                  <div class="col-4"><label class="wp-field-label"><span class="ess">최대사용하중</span></label><input type="text" class="form-control" v-model="lift.maxWorkLoad"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addLiftingEntry">
          <i class="icon-plus mr-5"></i>줄걸이 추가
        </button>
      </div>
    </div>

    <!-- 중량물 제원 -->
    <div v-if="permit.transportMethods.length > 0" class="form-group row">
      <label class="col-2 form-control-label"><span>중량물 제원</span></label>
      <div class="col-10 pt-2">
        <div v-for="(cargo, cIdx) in permit.cargoList" :key="cargo.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <span style="font-weight:600;">중량물 {{ cIdx + 1 }}</span>
            <button class="btn btn-xs line-2" @click="removeCargoEntry(cIdx)"
              :disabled="permit.cargoList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-4 mb-10"><label class="wp-field-label">품명</label><input type="text" class="form-control" v-model="cargo.name" placeholder="철근(상세제원 다발)"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">단위중량(kg)</label><input type="text" class="form-control" v-model="cargo.unitWeight" placeholder="00 kg"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">종류</label><input type="text" class="form-control" v-model="cargo.type" placeholder="철근 다발, 거푸집 등"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">고정방법</label><input type="text" class="form-control" v-model="cargo.fixMethod"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">형상</label><input type="text" class="form-control" v-model="cargo.shape" placeholder="박스형, 묶음형 등"></div>
              <div class="col-4 mb-10"><label class="wp-field-label"><span class="ess">총중량(kg)</span></label><input type="text" class="form-control" :value="cargo.totalWeight" readonly placeholder="총 양중수량 × 1회 양중중량 자동계산" style="background:#f4f4f4;"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">수직 운반거리(m)</label><input type="text" class="form-control" v-model="cargo.verticalDistance" placeholder="00 m"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">수평 운반거리(m)</label><input type="text" class="form-control" v-model="cargo.horizontalDistance" placeholder="00 m"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">필요작업반경(m)</label><input type="text" class="form-control" v-model="cargo.workRadius" placeholder="00 m"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">총 양중수량(개)</label><input type="text" class="form-control" v-model="cargo.totalQty" placeholder="00 개" @input="syncCargoTotalWeight(cargo)"></div>
              <div class="col-4 mb-10"><label class="wp-field-label">1회 양중수량(개)</label><input type="text" class="form-control" v-model="cargo.qtyPerLift" placeholder="00 개"></div>
              <div class="col-4 mb-0"><label class="wp-field-label">1회 양중중량(kg)</label><input type="text" class="form-control" v-model="cargo.weightPerLift" placeholder="00 kg" @input="syncCargoTotalWeight(cargo)"></div>
            </div>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addCargoEntry">
          <i class="icon-plus mr-5"></i>중량물 추가
        </button>
      </div>
    </div>

    <!-- 작업순서 및 안전 작업 방법 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>작업순서 및 안전 작업 방법</span></label>
      <div class="col-10 pt-2">
        <WorkProcedureTable :procedures="permit.procedures" @load-procedures="$emit('load-procedures')" />
      </div>
    </div>
  </div>
</template>

<script>
import EquipCommonFields from './EquipCommonFields.vue'
import WorkProcedureTable from './WorkProcedureTable.vue';
export default {
  name: 'HeavyLiftPermit',
  components: { EquipCommonFields, WorkProcedureTable },
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    }
  },
  methods: {
    addHeavyOperator() { this.permit.operators.push({ name: '', license: '', phone: '' }); },
    removeHeavyOperator(idx) { if (this.permit.operators.length > 1) this.permit.operators.splice(idx, 1); },
    addHeavyGuide() { this.permit.guides.push({ name: '', signalMethods: [], phone: '', wirelessMeans: '' }); },
    removeHeavyGuide(idx) { if (this.permit.guides.length > 1) this.permit.guides.splice(idx, 1); },
    addHeavyEquipmentEntry() {
      this.permit.equipmentList.push({ id: Date.now(), hasCertificate: null, modelName: '', manufacturer: '', registrationNo: '', manufactureYear: '', insuranceStatus: '', insuranceName: '', insuranceExpiry: '', regularInspectionDate: '', inspectionExpiry: '', capacity: '', workRadius: '', transport: '' });
    },
    removeHeavyEquipmentEntry(index) {
      if (this.permit.equipmentList.length > 1) {
        this.permit.equipmentList.splice(index, 1);
      }
    },
    addLiftingEntry() {
      this.permit.liftingList.push({ id: Date.now(), liftFeasible: '', riggingTools: [], riggingToolOther: false, riggingToolOtherText: '', auxiliaryTools: [], auxiliaryToolOther: false, auxiliaryToolOtherText: '', diameter: '', safeWorkLoad: '', riggingCount: '', loadFactor: '', safetyFactor: '', maxWorkLoad: '' });
    },
    removeLiftingEntry(index) {
      if (this.permit.liftingList.length > 1) {
        this.permit.liftingList.splice(index, 1);
      }
    },
    addCargoEntry() {
      this.permit.cargoList.push({ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' });
    },
    // 총중량 = 총 양중수량 × 1회 양중중량 (자동 계산, 단위/문자 제거 후 곱)
    syncCargoTotalWeight(cargo) {
      const num = (v) => {
        const n = parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, ''));
        return isFinite(n) ? n : null;
      };
      const qty = num(cargo.totalQty);
      const w = num(cargo.weightPerLift);
      cargo.totalWeight = (qty !== null && w !== null) ? String(Math.round(qty * w * 100) / 100) : '';
    },
    removeCargoEntry(index) {
      if (this.permit.cargoList.length > 1) {
        this.permit.cargoList.splice(index, 1);
      }
    },
  }
}
</script>